import styled from 'styled-components'

const Container__Main = styled.div``

export const Container = {
  main: Container__Main
}
